import request from "@/utils/request";

export function categoryList() {
    return request({
        url: '/settings/category/list',
        method: "get"
    });
}

//查询测试分类
export function getCategory(type, code) {
    return request({
        url: '/settings/category/find?type=' + type + '&code=' + code,
        method: "get"
    });
}